import React from 'react';
import { StandardLetterListing } from './StandardLetterListing';
import { LetterTemplateListing } from './LetterTemplateListing';
import { CompanyLetterTemplateListing } from './CompanyLetterTemplateListing';
import { LetterDesignForm } from './LetterDesignForm';

const eLetteringRoutes = [
  {
    props: {
      exact: true,
      path: '/general-settings/standard-letter',
    },
    component: <StandardLetterListing mode="general-settings" />,
  },
  {
    props: {
      exact: true,
      path:
        '/general-settings/standard-letter/:standardLetterID/letter-template/',
    },
    component: <LetterTemplateListing />,
  },
  {
    props: {
      exact: true,
      path:
        '/general-settings/standard-letter/:standardLetterID/letter-template/:letterTemplateID/design',
    },
    component: <LetterDesignForm />,
  },
  // --------------------------------------------------------------------------------------------------------------------------
  {
    props: {
      exact: true,
      path:
        '/company-setup/submenu/:companyID/company-standard-letter',
    },
    component: <StandardLetterListing mode="company-setup" />,
  },
  {
    props: {
      exact: true,
      path:
        '/company-setup/submenu/:companyID/company-standard-letter/:standardLetterID/company-letter-template/',
    },
    component: <CompanyLetterTemplateListing mode="company-setup" />,
  },
  {
    props: {
      exact: true,
      path:
        '/company-setup/submenu/:companyID/company-standard-letter/:standardLetterID/company-letter-template/:companyLetterTemplateID/design',
    },
    component: <LetterDesignForm mode="company-setup" />,
  },
];

export default eLetteringRoutes;
